import * as React from 'react';

interface LicenseProps {
  onClose?: () => void;
  imageUrl?: string;
}

const LicenseView: React.FunctionComponent<LicenseProps> = React.memo(
  (props) => {
    return (
      <>
        <div
          className="modal fade show in"
          id="exampleModal"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content rounded-0">
              <button
                type="button"
                className="close position-absolute top-0 bg-transparent text-white font-normal border-0 popup-close-outer"
                data-dismiss="modal"
                aria-label="Close"
                onClick={props.onClose}
              >
                <i className="icon-close"></i>
              </button>
              <div className="modal-body text-center">
                <img src={props.imageUrl} alt="" className="w-100" />
              </div>
            </div>
          </div>
        </div>
        <div className="modal-backdrop fade show"></div>
      </>
    );
  }
);

export default LicenseView;
